import { Button } from '@evertrue/et-components';
import PropTypes from 'prop-types';
import EmailSignature from './email-signature';

const EmailSignaturesList = ({
  selectedSignature = {},
  setSelectedSignature,
  signatures = [],
  handleAddSignature,
  updateSignature,
  handleDeleteSignature,
  handleDuplicateSignature,
  isModalOpen,
  openModal,
  closeModal,
  defaultSignature,
  onSetDefault,
}) => {
  return (
    <div className="email-signature-library">
      <div>
        <div className="email-signature-library--header">You can create up to 3 customized email signatures</div>
        <div className="email-signature-library--list">
          {!!signatures.length &&
            signatures.map((signature) => (
              <div key={signature.id}>
                <EmailSignature
                  signature={signature}
                  selectedSignature={selectedSignature}
                  setSelectedSignature={setSelectedSignature}
                  updateSignature={updateSignature}
                  handleDeleteSignature={handleDeleteSignature}
                  handleDuplicateSignature={handleDuplicateSignature}
                  defaultSignature={defaultSignature}
                  onSetDefault={onSetDefault}
                />
              </div>
            ))}
        </div>
      </div>
      <Button
        type="secondary"
        disabled={signatures.length > 3}
        className="email-signatures--add-btn"
        onClick={isModalOpen ? closeModal : openModal}
      >
        Add Signature
      </Button>
    </div>
  );
};

EmailSignaturesList.propTypes = {
  selectedSignature: PropTypes.object,
  setSelectedSignature: PropTypes.func.isRequired,
  signatures: PropTypes.array,
  handleAddSignature: PropTypes.func.isRequired,
  updateSignature: PropTypes.func.isRequired,
  handleDeleteSignature: PropTypes.func.isRequired,
  handleDuplicateSignature: PropTypes.func,
  isModalOpen: PropTypes.bool,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
  defaultSignature: PropTypes.object,
  onSetDefault: PropTypes.func,
};

export default EmailSignaturesList;
